module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/remote/card/card.component.scss
// module id = ./src/app/remote/card/card.component.scss
// module chunks = main